import React from 'react'
import { useSelector } from 'react-redux'
import { phoneFormat } from '../../helper/helper';

const ExctractedInformation = () => {
    const {app, chatDemo} = useSelector(state => state);
    return (
        <div className="rounded-3 p-4 text-start mb-lg-5 mb-md-3 bg-dark">
            <p className="textLight mb-1"># Display extracted information</p>
            <p className="text-white">
                <span className="text-warning">Value</span> ( <span className="text-success">'Traffic Source': </span> Google )
            </p>
            <p className="text-white">
                <span className="text-warning">Value</span> ( <span className="text-success">'Traffic Medium': </span> Organic )
            </p>
            <p className="text-white">
                <span className="text-warning">Value</span> ( <span className="text-success">'Phone Number': </span> {chatDemo.leadPhoneNumber ? phoneFormat(chatDemo.leadPhoneNumber) : ''} )
            </p>
            <p className="text-white">
                <span className="text-warning">Value</span> ( <span className="text-success">'Email': </span> {chatDemo.leadEmail} )
            </p>
            <p className="text-white">
                <span className="text-warning">Value</span> ( <span className="text-success">'Zip Code': </span> {chatDemo.leadZipcode} )
            </p>
            <p className="text-white">
                <span className="text-warning">Value</span> ( <span className="text-success">'Send lead': </span> {(chatDemo.leadPhoneNumber || chatDemo.leadEmail) ? 'Yes' : 'No'} )
            </p>
            <p className="text-white">
                <span className="text-warning">Value</span> ( <span className="text-success">'Transcript': </span> Send full transcript )
            </p>
        </div>
    )
}

export default ExctractedInformation